import { createUseStyles } from 'react-jss';
import colors from "../../utils/colors";

var styles = {
  comparisonBlock: {
    padding: '1.4rem 7rem',
    backgroundColor: colors.blue[100],
    borderTop: "0.1rem solid ".concat(colors.blue[200]),
    borderBottom: "0.1rem solid ".concat(colors.blue[200]),
    boxShadow: '0px 8px 9px -4px rgba(0, 0, 0, 0.14)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  compareTitle: {
    fontSize: '1.8rem',
    color: colors.neutral[900],
    marginRight: '2rem'
  },
  buttonsBlock: {
    display: 'flex',
    marginLeft: '2rem'
  },
  cancelButton: {
    marginRight: '2rem',
    backgroundColor: colors.neutral.white
  },
  comparedCardsList: {
    display: 'grid',
    maxWidth: '70%',
    gridTemplateColumns: 'repeat(auto-fill, minmax(22rem, 1fr))',
    padding: '0 2rem',
    borderRight: "0.1rem solid ".concat(colors.neutral[200]),
    borderLeft: "0.1rem solid ".concat(colors.neutral[200]),
    gap: '1.5rem'
  }
};

var createStyles = createUseStyles(styles);
export { createStyles };
//# sourceMappingURL=styles.js.map